import axios from "axios";
import config from "../config";

export function getMeetingNotesTemplates() {
  return axios.get(`${config.api_url}/meeting-notes-templates`);
}
